"use client";

import { Button } from "@/components";
import { Swiper, SwiperSlide } from "swiper/react";
import { getImageURL, useSwiperSliderOptions } from "@/lib";
import { Navigation } from "swiper/modules";

export const HomePageProductCategory = ({
    data = {},
    slug = "product_categories",
}) => {
    const { heading = "", list = [] } = data;

    const {
        nextSlide,
        prevSlide,
        sliderButtons: { hasNext, hasPrev },
        options: imagesSliderOptions,
    } = useSwiperSliderOptions({
        modules: [Navigation],
        loop: true,
        speed: 900,
        slidesPerView: 3,
        spaceBetween: 40,
        breakpoints: {
            0: {
                slidesPerView: 1,
                spaceBetween: 20,
            },
            640: {
                slidesPerView: 1,
                spaceBetween: 25,
            },
            768: {
                slidesPerView: 3,
                spaceBetween: 30,
            },
            1080: {
                slidesPerView: 3,
                spaceBetween: 35,
            },
            1280: {
                slidesPerView: 3,
                spaceBetween: 40,
            },
        },
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
    });

    if (!Array.isArray(list) || list.length === 0) {
        return null;
    }

    return (
        <>
            <section className="product_section">
                <div className="custom-container">
                    <div className="row justify-content-center">
                        <div className="col-12 col-lg-8 col-xl-6">
                            <div className="section_header text-center">
                                <h4
                                    className="heading fs-48 fw-300"
                                    dangerouslySetInnerHTML={{
                                        __html: heading,
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="product_home_bottome">
                    <div className="product_home_left" />
                    <div className="custom-container">
                        <div className="swiper product_home_slider">
                            <Swiper {...imagesSliderOptions}>
                                {list.map((item, idx) => {
                                    const { image, title, description, cta } =
                                        item || {};
                                    const imgSrc = image?.src
                                        ? getImageURL(image?.src)
                                        : "";
                                    const imgAlt = image?.alt || title || "";

                                    return (
                                        <SwiperSlide key={idx}>
                                            <div className="product_box">
                                                <div className="product_img">
                                                    {imgSrc && (
                                                        <img
                                                            src={imgSrc}
                                                            alt={imgAlt}
                                                        />
                                                    )}
                                                </div>
                                                <div className="fs-16 product_content">
                                                    <h3
                                                        className="fs-28"
                                                        dangerouslySetInnerHTML={{
                                                            __html: title,
                                                        }}
                                                    />
                                                    {description && (
                                                        <p
                                                            dangerouslySetInnerHTML={{
                                                                __html: description,
                                                            }}
                                                        />
                                                    )}
                                                    {cta?.title && (
                                                        <div className="produc_btn">
                                                            <Button
                                                                label={
                                                                    cta?.title
                                                                }
                                                                href={cta?.url}
                                                            />
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </SwiperSlide>
                                    );
                                })}
                            </Swiper>
                            <div className="product_home_btn">
                                <div className="product_home_btn swiper-button-next">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width={44}
                                        height={44}
                                        viewBox="0 0 44 44"
                                        fill="none"
                                    >
                                        <path
                                            d="M29.2043 22.9955L13.8786 37.598C13.6229 37.8418 13.2831 37.9778 12.9298 37.9778C12.5765 37.9778 12.2368 37.8418 11.9811 37.598L11.9646 37.5815C11.8402 37.4633 11.7411 37.3211 11.6734 37.1634C11.6058 37.0058 11.5709 36.836 11.5709 36.6644C11.5709 36.4928 11.6058 36.323 11.6734 36.1654C11.7411 36.0077 11.8402 35.8654 11.9646 35.7473L26.3966 21.9973L11.9646 8.25277C11.8402 8.1346 11.7411 7.99235 11.6734 7.83468C11.6058 7.67702 11.5709 7.50723 11.5709 7.33565C11.5709 7.16407 11.6058 6.99428 11.6734 6.83661C11.7411 6.67895 11.8402 6.5367 11.9646 6.41852L11.9811 6.40202C12.2368 6.15825 12.5765 6.02226 12.9298 6.02226C13.2831 6.02226 13.6229 6.15825 13.8786 6.40202L29.2043 21.0045C29.3391 21.1329 29.4464 21.2874 29.5197 21.4585C29.5931 21.6296 29.6309 21.8139 29.6309 22C29.6309 22.1862 29.5931 22.3704 29.5197 22.5415C29.4464 22.7127 29.3391 22.8671 29.2043 22.9955Z"
                                            fill="#5B5B5B"
                                        />
                                    </svg>
                                </div>
                                <div className="product_home_btn swiper-button-prev">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width={44}
                                        height={44}
                                        viewBox="0 0 44 44"
                                        fill="none"
                                    >
                                        <path
                                            d="M14.7957 22.9955L30.1214 37.598C30.3771 37.8418 30.7169 37.9778 31.0702 37.9778C31.4235 37.9778 31.7632 37.8418 32.0189 37.598L32.0354 37.5815C32.1598 37.4633 32.2589 37.3211 32.3266 37.1634C32.3942 37.0058 32.4291 36.836 32.4291 36.6644C32.4291 36.4928 32.3942 36.323 32.3266 36.1654C32.2589 36.0077 32.1598 35.8654 32.0354 35.7473L17.6034 21.9973L32.0354 8.25277C32.1598 8.1346 32.2589 7.99235 32.3266 7.83468C32.3942 7.67702 32.4291 7.50723 32.4291 7.33565C32.4291 7.16407 32.3942 6.99428 32.3266 6.83661C32.2589 6.67895 32.1598 6.5367 32.0354 6.41852L32.0189 6.40202C31.7632 6.15825 31.4235 6.02226 31.0702 6.02226C30.7169 6.02226 30.3771 6.15825 30.1214 6.40202L14.7957 21.0045C14.6609 21.1329 14.5536 21.2874 14.4803 21.4585C14.4069 21.6296 14.3691 21.8139 14.3691 22C14.3691 22.1862 14.4069 22.3704 14.4803 22.5415C14.5536 22.7127 14.6609 22.8671 14.7957 22.9955Z"
                                            fill="#5B5B5B"
                                        />
                                    </svg>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="product_home_right" />
                </div>
            </section>
        </>
    );
};
